import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { ControlledField, DatePickerInputField, getDateLongFormatWithLocale } from 'remote/global';

interface Props {
  formInstance: UseFormReturn<any>;
  name: string;
  translationKey?: string;
}

function DatePickerField(props: Props) {
  const { formInstance, name, ...rest } = props;
  const tInstance = useTranslation();
  const { control } = formInstance;
  const { i18n } = tInstance;

  return (
    <ControlledField
      control={control}
      name={name}
      render={(renderProps) => (
        <DatePickerInputField
          {...renderProps}
          fieldProps={{
            onChange: (date) => {
              if (dayjs(date as Date).isValid()) {
                const formattedDate = dayjs(date as Date).format('YYYY-MM-DD');
                renderProps.field.onChange(formattedDate);
                return;
              }
              renderProps.field.onChange(null);
            },
            disablePast: true,
            shouldDisableDate: (date) => date < new Date(),
            format: getDateLongFormatWithLocale(i18n.language),
          }}
          {...rest}
        />
      )}
    />
  );
}

export default DatePickerField;
